import { Menu, Button } from '@oliasoft-open-source/react-ui-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { languageList } from '~common/Internationalisation/language-list';
import { loadLocalStoreData, saveLocalStoreData } from '../../services/local-storage.service';

const LanguagePicker = () => {
  const { i18n } = useTranslation();
  const initLanguage = loadLocalStoreData('locales',  'en');
  const [lang, setLang] = useState(initLanguage);

  const onChangeLanguage = async (lang) => {
    const { languageSelected } = lang;
    await i18n.changeLanguage(languageSelected);
  };

  const onChangeHandler = (value) => {
    setLang(value);
    const updatedLanguage = { languageSelected: value };
    onChangeLanguage(updatedLanguage).then(() => saveLocalStoreData('locales', value));
  };

  const getCurrentLanguage = () => {
    const currentLanguage = localStorage.getItem('locales') || 'en';
    return languageList.find(lng => lng.value === currentLanguage);
  };

  return (
    <Menu
      menu={{
        trigger: 'Component',
        component: <Button label={getCurrentLanguage().isoCode} basic />,
        sections: languageList.map((item) => ({
          type: 'Option',
          label: item.label,
          onClick: () => onChangeHandler(item.value),
          selected: item.value === lang,
        })),
        placement: 'bottom-end',
      }}
    />
  );
};

export default LanguagePicker;
